/* React Imports */
import { useEffect, useState } from "react";
import i18n from "i18next";

/* Fluent UI Imports */
import {
  Button,
  Dropdown,
  SearchBox,
  Tab,
  TabList,
  Option,
} from "@fluentui/react-components";
import { AirplaneTakeOffRegular, SearchRegular } from "@fluentui/react-icons";

/* Internal Imports */
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { INormBolzen } from "../../../Models/INormBolzen";
import { INormCollar } from "../../../Models/INormCollar";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import Header from "../../Layout/Header";
import { getCollarColumns } from "./CollarColumns";
import { getBolzenColumns } from "./BolzenColumns";
import AerospaceDialog from "../../ConfiST/AerospaceDialog";

export default function AerospaceNorm() {
  /* States */
  const [selectedCheckbox, setSelectedCheckbox] =
    useState<string>("abreissCollar");
  const [selectedTab, setSelectedTab] = useState<string>("collar");
  const [searchValue, setSearchValue] = useState<string>("");
  const [normBolzen, setNormBolzen] = useState<INormBolzen[]>([]);
  const [normCollar, setNormCollar] = useState<INormCollar[]>([]);
  const [filterNormBolzen, setFilterNormBolzen] = useState<INormBolzen[]>([]);
  const [filterNormCollar, setFilterNormCollar] = useState<INormCollar[]>([]);

  const [isAerospaceDialogOpen, setIsAeroSpaceDialogOpen] =
    useState<boolean>(false);

  /* Effects */
  useEffect(() => {
    getNormBolzen();
    getNormCollar();
  }, []);

  useEffect(() => {
    if (normBolzen && normCollar) {
      if (selectedTab == "bolzen") {
        if (searchValue) {
          var newList = normBolzen.filter((item) =>
            item.norm.includes(searchValue)
          );
          setFilterNormBolzen(newList);
        } else {
          setFilterNormBolzen(normBolzen);
        }
      } else if (selectedTab == "collar") {
        var newList1 = undefined;
        if (selectedCheckbox == "abreissCollar") {
          newList1 = normCollar.filter(
            (item) => item.abreiss_Collar != undefined
          );
        } else if (selectedCheckbox == "holdndrive") {
          newList1 = normCollar;
        } else if (selectedCheckbox == "drehmoment") {
          newList1 = normCollar.filter(
            (item) => item.drehmoment_Verschraubung != undefined
          );
        }
        if (newList1) {
          var newList2 = newList1.filter((item) =>
            item.norm.toLowerCase().includes(searchValue.toLowerCase())
          );
          setFilterNormCollar(newList2);
        }
      }
    }
  }, [selectedTab, searchValue, selectedCheckbox, normBolzen, normCollar]);

  /* Functions */
  const getNormBolzen = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/configurator/GetNormBolzen`)
      .then((data: INormBolzen[]) => {
        setNormBolzen(data);
      });
  };

  const getNormCollar = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/configurator/GetNormCollar`)
      .then((data: INormCollar[]) => {
        setNormCollar(data);
      });
  };

  const collarColumns = getCollarColumns(searchValue);
  const bolzenColumns = getBolzenColumns(searchValue);

  return (
    <div>
      <Header
        HTMLElement={
          <>
            <Button
              icon={<AirplaneTakeOffRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
              onClick={() => {}}
            >
              {i18n.t<string>("aerospaceNorm")}
            </Button>
          </>
        }
      />

      <AerospaceDialog
        isDialogOpen={isAerospaceDialogOpen}
        onDismiss={() => {
          setIsAeroSpaceDialogOpen(false);
        }}
        onSelectNorm={() => {
          setIsAeroSpaceDialogOpen(false);
        }}
        schraubfall={""}
      />

      <div className="lueb-InnerContentBlockPadding2px">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{}}>
            <Dropdown
              value={
                selectedCheckbox == "holdndrive"
                  ? "Hold + Drive"
                  : i18n.t<string>(selectedCheckbox)
              }
            >
              <Option
                onClick={() => {
                  setSelectedCheckbox("abreissCollar");
                }}
                key={"abreissCollar"}
              >
                {i18n.t<string>("abreissCollar")}
              </Option>
              <Option
                onClick={() => {
                  setSelectedCheckbox("holdndrive");
                }}
                key={"holdndrive"}
              >
                Hold + Drive
              </Option>
              <Option
                onClick={() => {
                  setSelectedCheckbox("drehmoment");
                }}
                key={"drehmoment"}
              >
                {i18n.t<string>("drehmoment")}
              </Option>
            </Dropdown>

            <Button
              appearance="transparent"
              icon={<SearchRegular />}
              onClick={() => setIsAeroSpaceDialogOpen(true)}
            >
              {i18n.t<string>("datenAusAeroSpaceNorm")}
            </Button>
          </div>

          <div>
            <SearchBox
              onChange={(ev, val) => {
                setSearchValue(val.value);
              }}
              appearance="outline"
            />
          </div>
        </div>
      </div>
      <TabList selectedValue={selectedTab}>
        <Tab
          onClick={() => {
            setSelectedTab("collar");
          }}
          value="collar"
        >
          {i18n.t<string>("collar")}
        </Tab>
        <Tab
          onClick={() => {
            setSelectedTab("bolzen");
          }}
          value="bolzen"
        >
          {i18n.t<string>("bolzen")}
        </Tab>
      </TabList>
      <div className="lueb-ContentBlock">
        <div
          style={{
            minWidth: "550px",
            overflowX: "scroll",
            overflowY: "hidden",
          }}
        >
          {selectedTab == "collar" && (
            <LuebPagedDataGrid
              items={filterNormCollar}
              columns={collarColumns}
              resizableColumns
              sortable
              columnSizingOptions={{}}
            />
          )}
          {selectedTab == "bolzen" && (
            <LuebPagedDataGrid
              items={filterNormBolzen}
              columns={bolzenColumns}
              resizableColumns
              sortable
              columnSizingOptions={{}}
            />
          )}
        </div>
      </div>
    </div>
  );
}
